<template>
  <TariffNotificationModal
      ref="modalRef"
      title="Формируете свой тариф самостоятельно"
      @button-click="onConfirm"
      @hidden="emit('hidden')"
      button-text="Оформить подписку"
      :max-width="450"
  >

    <template #default>
        <p class="trial-expired-modal__text mb-3">
            Пробный период закончился, вам доступно 3 ученика, чаты, учет финансов, добавление своих материалов.
        </p>
        <ul class="trial-expired-modal__accent mb-3">
            <li>Если у вас добавлено более 3 учеников, ученики сверх лимита будут автоматически перемещены в архив.</li>
            <li>Все созданные доски сохранятся в материалах, но доступ к ним будет ограничен до подключения опции «Онлайн-доска».</li>
            <li>Без подключения опции «Звонки» проведение онлайн-занятий будет недоступно.</li>
        </ul>
        <p class="trial-expired-modal__text">
            Выбирайте удобный набор возможностей и оплачивайте только то, чем пользуетесь.
        </p>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const emit = defineEmits<{
    (e: 'hidden'): void;
    (e: 'confirm'): void;
}>();

function onConfirm() {
    emit('confirm');
}

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});

</script>

<style lang="scss" scoped>
.trial-expired-modal__text {
    font-size: 14px;
}

.trial-expired-modal__accent {
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    background-color: #e763ae;
    border-radius: 8px;
    padding: 12px 12px 12px 28px;
}
</style>



